var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9996 29.3822C33.4018 29.0235 30.4132 27.589 29.8155 27.4695C29.2178 27.2304 28.8592 27.2304 28.5005 27.8281C28.1419 28.4258 26.9465 29.7408 26.5878 30.219C26.2292 30.5776 25.8706 30.6972 25.2728 30.3385C24.6751 30.0994 22.7624 29.3822 20.3715 27.3499C18.5784 25.7959 17.3829 23.7636 17.0243 23.1659C16.6657 22.5682 17.0243 22.3291 17.2634 21.9705C17.8611 21.1336 18.5784 20.2968 18.8175 19.9382C19.0566 19.5796 18.8175 19.2209 18.8175 18.8623C18.6979 18.5037 17.5025 15.6346 16.9048 14.4392C16.4266 13.2437 15.9484 13.4828 15.5898 13.3633C15.2311 13.3633 14.8725 13.3633 14.3943 13.3633C13.9162 13.3633 13.3184 13.4828 12.8403 14.0805C12.2426 14.6783 10.6885 16.1128 10.6885 19.1014C10.6885 22.09 12.8403 24.8395 13.1989 25.3177C13.5575 25.6763 17.5025 31.7731 23.4797 34.2835C24.9142 34.8812 25.9901 35.2398 26.9465 35.5985C28.381 36.0766 29.696 35.9571 30.7719 35.8376C31.9673 35.718 34.3582 34.403 34.8364 32.9685C35.3145 31.534 35.3145 30.3385 35.195 30.0994C35.0755 29.8604 34.5973 29.7408 33.9996 29.3822Z",
    fill: "#D1DBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.433 25.7937C45.4767 36.3135 38.0586 45.2793 26.9088 46.2357C21.3225 47.2155 20.5128 47.192 17.5242 46.2357C14.5356 45.2793 15.4711 45.1598 14.8734 45.2793L7.22258 48.8657C5.42942 49.7025 3.51672 48.1484 3.99489 46.2357L5.78805 38.9435C6.02714 38.2263 5.78805 37.509 5.30988 36.9113C2.08219 32.4881 0.528117 26.9891 1.12584 21.0119C2.32128 10.6116 10.8089 2.24351 21.3288 1.16761C31.8486 0.0917168 47.5089 11.5679 46.1939 25.7937H46.433Z",
    stroke: "#D1DBE3",
    strokeWidth: 1.4,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.d2b70b02.svg";
export { ForwardRef as ReactComponent };